import {Async, Loaded, Loading} from 'Core/models/Async';

export class UnassignedAUEErrorMessages {
  public readonly key = 'UnassignedAUEErrorMessages';
}

export type AUEErrorMessages = Async<object[]> | UnassignedAUEErrorMessages;

type MatchAUEErrorMessagesOptions<TReturn> = {
  Loading: () => TReturn;
  Loaded: (aueErrorMessages: object[]) => TReturn;
  Error: () => TReturn;
  Unassigned: (aueErrorMessages: []) => TReturn;
};

export const isLoading = (aueErrorMessages: AUEErrorMessages): aueErrorMessages is Loading<object[]> =>
  aueErrorMessages.key === 'Loading';

export const isLoaded = (aueErrorMessages: AUEErrorMessages): aueErrorMessages is Loaded<object[]> =>
  aueErrorMessages.key === 'Loaded';

export const matchAUEErrorMessages = <TReturn>(options: MatchAUEErrorMessagesOptions<TReturn>) => (
  aueErrorMessages: AUEErrorMessages
) => {
  switch (aueErrorMessages.key) {
    case 'UnassignedAUEErrorMessages':
      return options.Unassigned([]);
    case 'Loaded':
      return options.Loaded(aueErrorMessages.Data);
    case 'Loading':
      return options.Loading();
    case 'Conflict':
      return options.Error();
    case 'ServerError':
      return options.Error();
    case 'Unauthorized':
      return options.Error();
  }
};
